export default {
  brewery: 'sapwoodCellars',
  info_url: 'http://landing.tavour.com/sapwoodCellars/',
  title: {
    in_progress: '',
    success: 'You have joined the Sapwood Cellar Out-of-State Membership Club!',
    subtext: "Join Sapwood Cellar's Out-of-State Membership Club",
    sub_subtext: 'Sapwood Cellars was founded in 2018 by brewing authors Mike Tonsmeire and Scot Janish.\n' +
      'This club is one of the only ways to try Sapwood Cellar Beers outside of Maryland.  \n' +
      'By joining the club, you\'ll receive 6 delicious barrel-aged sour beers a few times per year.',
  },
  review: {
    summary: [
      'You are joining the Sapwood Cellars Out-of-State Membership Club where you will receive 6 delicious barrel-aged sour beers a few times per year.' +
      'By signing up, your credit card will automatically be charged $146.' +
      'You will have the opportunity to "opt out" before your card is charged by emailing info@sapwoodcellars.com or support@tavour.com.' +
      'You\'ll receive a notification when the box is charged. ',
    ],
    button_text: 'Join the Club!',
  },
};



// WEBPACK FOOTER //
// ./src/settings/sapwoodCellars.js